module.exports = __webpack_public_path__ + "static/media/energy_savings_bg_icon_svg.ea259787.svg";